import { isProd } from '@/utils/environment'

// Programme beta : features activées en anticipé par compte depuis l'admin (catalogue : engine src/enums/betaFeatures.js).
// Une clé absente du catalogue renvoyé par l'engine = feature sortie de beta, accessible à tous.

function currentUser(user) {
  if (user && (user.email || user.account)) return user
  try {
    return localStorage.user && localStorage.user !== 'undefined' ? JSON.parse(localStorage.user) : null
  } catch (e) {
    return null
  }
}

export function isStaffEmail(email) {
  return String(email || '').trim().toLowerCase().endsWith('@mashup-web.com')
}

// Compte inscrit au programme beta pour cette feature (user._premium.program_beta, via /users/me)
export function betaProgramHas(key, user) {
  const u = currentUser(user)
  const beta = u && u._premium && u._premium.program_beta
  if (!beta || !Array.isArray(beta.catalog)) return false
  return !beta.catalog.includes(key) || (beta.enabled || []).includes(key)
}

// Accès à une feature beta : hors prod, staff, ou compte inscrit au programme beta
export function hasBetaFeature(key, user) {
  if (!isProd()) return true
  const u = currentUser(user)
  if (!u) return false
  return isStaffEmail(u.email) || betaProgramHas(key, u)
}

// Double authentification des users : sandbox, ou comptes du programme beta (sans exception staff : l'engine n'ouvre la 2FA
// qu'aux comptes inscrits). Pour l'ouvrir à tous : retirer '2fa' du catalogue engine ou passer user_security.enabled à true.
export function mfaFeatureEnabled(user) {
  return !isProd() || betaProgramHas('2fa', user)
}
